{
  "version": 1,
  "asset_id": "22351d32-1fdc-4d8b-8d61-f0ec42261a72",
  "project_id": "288ffafd-b4ec-4687-a58e-f3a6c56e4541",
  "url": "/__l5e/assets-v1/22351d32-1fdc-4d8b-8d61-f0ec42261a72/home-verhuislift-appartement.jpg",
  "r2_key": "a/v1/288ffafd-b4ec-4687-a58e-f3a6c56e4541/22351d32-1fdc-4d8b-8d61-f0ec42261a72/home-verhuislift-appartement.jpg",
  "original_filename": "home-verhuislift-appartement.jpg",
  "size": 2963764,
  "content_type": "image/jpeg",
  "created_at": "2026-08-27T21:47:53Z"
}
